import React from 'react'

const EmptyLink: React.FC<React.PropsWithChildren<{ onClick: VoidFunction }>> = ({
  onClick,
  children,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    onClick()
  }

  return (
    <a href='/' onClick={handleClick}>
      {children}
    </a>
  )
}
export default EmptyLink
